import { Component, HostBinding, OnInit, Renderer2 } from '@angular/core';
import { RouteService } from 'src/app/core/services/route.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss'],
})
export class ProgressComponent implements OnInit {
  items: Array<String> = [
    'Create app',
    'Create Table(s)',
    'Create Fields',
    'Create Relationships',
    'Create Reports',
    'Create Forms',
    'Add Data',
    'Create Dashboards',
  ];
  isVisible: boolean = false;
  activeStep: number = 0;
  subsink = new SubSink();

  constructor(private renderer: Renderer2, private route: RouteService) {}

  ngOnInit(): void {
    this.loadSubscribers();
    this.setActiveStep(this.route.currentRoute());
  }

  /**
   * Toggle progress bar
   */
  toggle() {
    this.isVisible = !this.isVisible;
  }

  /**
   * Subscribers
   */
  loadSubscribers = () => {
    this.subsink.sink = this.route.change().subscribe((data: any) => {
      this.setActiveStep(data.url);
    });
  };

  setActiveStep = (url: string) => {
    if (url.includes('/application')) {
      this.activeStep = 2;
    } else if (url.includes('/field')) {
      this.activeStep = 3;
    } else if (url.includes('/relation')) {
      this.activeStep = 4;
    } else if (url.includes('/report') && !url.includes('/viewdatatable')) {
      this.activeStep = 5;
    } else if (url.includes('/form')) {
      this.activeStep = 6;
    } else {
      this.activeStep = -1;
    }
  };

  ngOnDestroy(){
    this.subsink.unsubscribe();
  }

  /**
   * Total steps
   */
  totalSteps = () => this.items.length;

  @HostBinding('class') class = 'progress-root-sidebar';
}
